import React from 'react';
import './style.scss';
import { withTranslation } from 'react-i18next';
import { FormControl, MenuItem, Select } from '@mui/material';
import { Image, Text } from '@sitecore-jss/sitecore-jss-react';
import { CustomAutocompleteArrowIcon } from '../../../../Shared/components/controls/Autocomplete/shared/icons/index.js';

const HeaderLanguageSwitcher = (props) => {
  const { i18n, languages, isEliteTheme } = props;

  const handleChange = (newLanguageVal) => {
    const newLanguage = i18n.language === 'en' ? newLanguageVal : 'en';
    const oldLanguage = i18n.language;
    const oldRoute = window.location.href;
    let newRoute = oldRoute.replace(oldLanguage, newLanguage);
    if (newRoute === oldRoute) {
      const pathName = window.location.pathname;
      // then this is the base url
      if (pathName === '/') {
        newRoute = `${newLanguage}/`;
      } else if (pathName.indexOf(`/${oldLanguage}`) === -1) {
        newRoute = `${newLanguage}${pathName}`;
      }
    }
    window.location.assign(newRoute);
  };

  return languages.length > 1 ? (
    <FormControl>
      <Select
        value={i18n.language}
        onChange={(e) => handleChange(e.target.value)}
        autoWidth
        variant="standard"
        className="language-selector"
        IconComponent={(props) => <CustomAutocompleteArrowIcon color="#FFF" {...props} />}
        MenuProps={{
          anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
          transformOrigin: { vertical: 'top', horizontal: 'left' },
          className: isEliteTheme
            ? 'language-selector-popover theme-elite'
            : 'language-selector-popover',
        }}
      >
        {languages.map((language, index) => (
          <MenuItem value={language.fields.cultureCode.value} key={index}>
            <LanguageItem data={language.fields} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  ) : null;
};

const LanguageItem = ({ data }) => (
  <div className="language-item">
    {data.languageIcon?.value?.src && (
      <Image field={data.languageIcon} className="language-item-image" />
    )}
    <div className="language-item-code">
      <span>{capitalize(data.title.value)}</span>
    </div>
    <div className="language-item-title">
      <Text field={data.title} />
    </div>
  </div>
);

const capitalize = (input) => {
  if (!input || typeof input !== 'string') return input;
  const splitted = input.split('');
  return splitted[0].toUpperCase() + splitted.slice(1).join('');
};

export default withTranslation()(HeaderLanguageSwitcher);
